/** @jsx jsx */
import { jsx } from "theme-ui"
import InfoIcon from "../images/info-icon.svg"
import PageLink from "./page-link"

const InfoIconLink = ({ to, alt, sx }) => {
  return (
    <PageLink link={to}>
      <img
        sx={{
          display: "inline",
          width: 20,
          position: "relative",
          top: "4px",
          ml: 1,
          ...sx,
        }}
        src={InfoIcon}
        alt={alt}
      />
    </PageLink>
  )
}

export default InfoIconLink
